export var AssetFilePermission;
(function (AssetFilePermission) {
    AssetFilePermission["PUBLIC"] = "public";
    AssetFilePermission["PRIVATE"] = "private";
})(AssetFilePermission || (AssetFilePermission = {}));
export var FileSelectionFieldType;
(function (FileSelectionFieldType) {
    FileSelectionFieldType["FILE"] = "file";
    FileSelectionFieldType["IMAGE"] = "image";
})(FileSelectionFieldType || (FileSelectionFieldType = {}));
